export default __webpack_public_path__ + "static/media/cycloneofsteel5.1c62cdc3.png";